import React from 'react';
import { useObservable } from 'react-use-observable';

import { Alert, Typography } from 'antd';

import { numberToBRL } from 'v2/helpers/money';
import { anticipationService } from 'v2/services/anticipation';

function AnticipateStep() {
  const [anticipationBalance] = useObservable(() => anticipationService.getCurrentBalance(), []);
  const anticipationFormatted = typeof anticipationBalance === 'number' ? numberToBRL(anticipationBalance) : '-';

  return (
    <div className='flex flex-col gap-4'>
      <Typography.Text type='secondary'>Saldo disponível para antecipação</Typography.Text>

      <div className='flex items-center justify-between gap-4'>
        <Typography.Text type='secondary'>Valor:</Typography.Text>
        <Typography.Text strong>{anticipationFormatted}</Typography.Text>
      </div>

      <Alert
        type='info'
        showIcon
        message={
          <>
            Você tem <Typography.Text strong>{anticipationFormatted}</Typography.Text> disponível para antecipação,
            deseja antecipar o valor?
          </>
        }
      />
    </div>
  );
}

export default AnticipateStep;
